import { ModalWithIcon } from '@components/ModalWithIcon/ModalWithIcon'
import { WizardStepProps } from '@components/Wizard/Wizard'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import PrimaryButton from '@components/PrimaryButton/PrimaryButton'
import Checkbox from '@components/Checkbox/Checkbox'
import { openLink, safeAreaInset } from '@lib/telegram'
import MenuItem from '@components/MenuItem/MenuItem'

// Styled components
const Container = styled.div`
  padding: 0 4vw 24px 4vw;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100vh;
  overflow: hidden;
`

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
  padding: 24px 0px;
`

const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: ${safeAreaInset().bottom === 0 ? 0 : safeAreaInset().bottom - 24}px;
`

const UserAgreementStep: React.FC<WizardStepProps> = ({ onNext }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isAgreed, setIsAgreed] = useState(false)

  const handleAgree = async () => {
    if (isAgreed) {
      setIsModalVisible(true)
    }
  }

  const handleModalClose = () => {
    setIsModalVisible(false)
    onNext?.()
  }

  const handleCheckboxChange = () => {
    setIsAgreed(!isAgreed)
  }

  return (
    <Container>
      <MenuContainer>

        <MenuItem
          title={t('legalCompliance.menuItems.privacyPolicy')}
          iconType="link"
          onClick={() => openLink(`https://jagad.to/privacypolicy`)}
        />
        <MenuItem
          title={t('legalCompliance.menuItems.termsAndConditions')}
          iconType="link"
          onClick={() => openLink(`https://jagad.to/termscondition`)}
        />

      </MenuContainer>

      <ButtonContainer>
        <CheckboxContainer>
          <Checkbox
            checked={isAgreed}
            onChange={handleCheckboxChange}
            label={t('page.createWallet.steps.userAgreement.checkbox')}
          />
        </CheckboxContainer>
        <PrimaryButton
          onClick={handleAgree}
          disabled={!isAgreed}
        >
          {t('page.createWallet.steps.userAgreement.continueButton')}
        </PrimaryButton>
      </ButtonContainer>

      <ModalWithIcon
        title={t('page.createWallet.steps.userAgreement.modal.title')}
        description={t('page.createWallet.steps.userAgreement.modal.description')}
        positiveText={t('page.createWallet.steps.userAgreement.modal.positiveText')}
        onPositive={handleModalClose}
        visible={isModalVisible}
        type="welcome"
        closeButton={false}
        onClose={handleModalClose}
        onModalOverlayClick={handleModalClose}
        additionalContent={{
          title: t('page.createWallet.steps.userAgreement.modal.additionalTitle'),
          description: t('page.createWallet.steps.userAgreement.modal.additionalDescription')
        }}
        iconContainerStyle={{ margin: '24px 0' }}
      />
    </Container>
  )
}
export default UserAgreementStep